import { DropdownOption } from "@benefitsui/app/lib/common.types";
import { RadioSelectData } from "@dxo/ng-swift-ui";
import { LeaveType } from "@benefitsui/app/shared/enums/leaveTypes";
import { MASTER_STATE_LIST } from "@benefitsui/app/shared/utilities/state-utilities";

/**
 * State dropdown options for form components
 * Transforms the master state list into dropdown format
 */
export const stateList: DropdownOption<string>[] = MASTER_STATE_LIST.map(state => ({
  key: state.abbreviation,
  displayName: state.fullName
}));

  const labels = {
    adoption: 'Adoption or foster care responsibilities',
    attendMilitaryEvent: 'Attend military event for a service member',
    bondingLeave: 'Bonding with a newborn or newly adopted child',
    deathADD: 'Death and/or AD&D',
    employeeIllness: 'Illness or illness-related surgery',
    employeeInjury: 'Injury or injury-related surgery',
    familyCare: 'Care for a family member',
    militaryCare: 'Care for a military service member',
    timeAway: 'Time away from work',
    other: 'Other (personal leave of absence)',
    ppl: 'Personal protected leave',
    pregnancy: 'Pregnancy'
  }

  //multiselect options
  export const claimTypeData: RadioSelectData[] = [
    { id: 'timeAway', name: 'timeAway', value: 'timeAway', label: labels.timeAway },
    { id: 'deathAD&D', name: 'deathAD&D', value: 'deathAD&D', label: labels.deathADD }
  ];

  export const timeAwayData: RadioSelectData[] = [
    {
      id: LeaveType.EmployeeIllness,
      name: LeaveType.EmployeeIllness,
      value: LeaveType.EmployeeIllness,
      label: labels.employeeIllness
    },
    {
      id: LeaveType.EmployeeInjury,
      name: LeaveType.EmployeeInjury,
      value: LeaveType.EmployeeInjury,
      label: labels.employeeInjury
    },
    {
      id: LeaveType.Pregnancy,
      name: LeaveType.Pregnancy,
      value: LeaveType.Pregnancy,
      label: labels.pregnancy
    },
    {
      id: LeaveType.FamilyCare,
      name: LeaveType.FamilyCare,
      value: LeaveType.FamilyCare,
      label: labels.familyCare
    },
    {
      id: LeaveType.BondingLeave,
      name: LeaveType.BondingLeave,
      value: LeaveType.BondingLeave,
      label: labels.bondingLeave
    },
    {
      id: LeaveType.Adoption,
      name: LeaveType.Adoption,
      value: LeaveType.Adoption,
      label: labels.adoption
    },
    {
      id: LeaveType.MilitaryCare,
      name: LeaveType.MilitaryCare,
      value: LeaveType.MilitaryCare,
      label: labels.militaryCare
    },
    {
      id: LeaveType.AttendMilitaryEvent,
      name: LeaveType.AttendMilitaryEvent,
      value: LeaveType.AttendMilitaryEvent,
      label: labels.attendMilitaryEvent
    },
    {
      id: LeaveType.PPL,
      name: LeaveType.PPL,
      value: LeaveType.PPL,
      label: labels.ppl
    },
    {
      id: LeaveType.Other,
      name: LeaveType.Other,
      value: LeaveType.Other,
      label: labels.other
    }
  ];